import { Node } from "../node";

export class MissingVisitTypeNode extends Node {
  get defaults() {
    return {
      id: "missing-visit-type",
      name: "MissingVisitTypeNode",
    };
  }

  get message() {
    return "|PROVIDER-NAME| does not currently have any |SELECTED-VISIT-TYPE| appointments available for |PATIENT-TYPE| patients.";
  }
}
